
import Vue, { PropType } from "vue"
import axios, { AxiosError, AxiosResponse } from "axios"
import { EventBus } from "@/plugins/eventBus"
import { Company } from "@/types/Company"

export default Vue.extend({
    name: "CompanyAutocompleteMixin",
    props: {
      company_id: {
        type: Number,
        default: null
      },
      space_id: {
        type: Number,
        default: null
      },
      is_group: {
        type: [Boolean, null] as PropType<boolean | null>,
        default: true
      }
    },
    data: () => ({
        companies: [] as Company[],
        searchCompanies: "" as string,
        selectedCompany: null as Company | null,
    }),
    watch: {
      searchCompanies(val: string) {
        this.getCompanies(val)
      }
    },
    mounted() {
      this.getCompanies()
    },
    methods: {
      /**
       * Retrieves the list of companies
       * @param search Optional search term
       */
      getCompanies(search: string|null = null, is_group: boolean|null = null) {
        let url = `/v1/company`
        const params: string[] = []
        
        // Only add is_group parameter if it's not null
        if (this.is_group !== null) {
          params.push(`is_group=${this.is_group}`)
        }
        
        if (search) {
          params.push(`searches=${encodeURIComponent(search)}`)
        }

        params.push(`fields=id,space_id,name,trade_name,address,postal_code,city,country,address_position,client_id`)
        
        url += `?${params.join('&')}`
        axios
        .get(url)
        .then((response: AxiosResponse) => {
          this.companies = response.data
        })
        .catch((error: AxiosError) => {
          EventBus.$emit('snackbar',{axiosError: error})
        })
      },
      /**
       * Gets the display name of a company
       * @param company The company
       * @returns The display name
       */
      getCompanyDisplayName(company: Company): string {
        if (company.trade_name && company.trade_name !== company.name) {
          return `${company.trade_name} (${company.name})`
        }
        return company.name
      },
    }
})
